import {
  sharedStory1,
  sharedStory2,
  sharedStory3,
} from '../assets/index'

const transformingYouthArticle = [
  {
    type: 'intro',
    paragraphs: [
      'Youth are the foundation of a strong and progressive nation. With the right guidance, values, and opportunities, young individuals can become confident leaders capable of creating meaningful social change. Leadership is not only about holding positions of authority — it is about responsibility, discipline, vision, and the ability to inspire others.',
      'At Disha Foundation, we believe that empowering youth through education, mentorship, and service helps shape a generation that is prepared to lead with purpose and integrity.',
    ],
  },
  {
    type: 'section',
    heading: 'Why Youth Leadership Matters',
    paragraphs: [
      'Today’s world needs young leaders who are socially responsible, culturally aware, and committed to positive transformation. Leadership skills help youth:',
    ],
    list: [
      'Build confidence and self-discipline',
      'Improve communication and teamwork',
      'Develop decision-making abilities',
      'Learn responsibility and accountability',
      'Create solutions for social challenges',
      'Contribute towards nation-building',
    ],
    closingParagraphs: [
      'By nurturing leadership qualities early, youth gain the ability to make informed decisions and inspire communities around them.',
    ],
  },
  {
    type: 'section',
    heading: 'The Role Of Education & Mentorship',
    paragraphs: [
      'Education is one of the most powerful tools for youth development. Beyond academics, values-based education helps students understand ethics, leadership, and civic responsibility.',
      'Mentorship plays an equally important role by guiding young individuals toward personal growth and career development. Through mentorship, youth receive motivation, practical knowledge, and support to overcome challenges and achieve their goals.',
    ],
  },
  {
    type: 'section',
    heading: 'Building Leaders Through Service',
    paragraphs: [
      'Community service teaches empathy, teamwork, and social awareness. Participating in volunteer activities allows youth to understand real-world challenges while developing leadership skills through action.',
    ],
    list: [
      'Social awareness campaigns',
      'Environmental initiatives',
      'Youth workshops',
      'Health & fitness drives',
      'Community outreach programs',
    ],
    closingParagraphs: [
      'help young individuals become responsible citizens dedicated to serving society.',
    ],
  },
  {
    type: 'section',
    heading: 'Developing Essential Leadership Skills',
    paragraphs: [
      'Future leaders require more than academic success. They need practical life skills that prepare them for real-world responsibilities.',
    ],
    list: [
      'Communication Skills',
      'Problem Solving',
      'Critical Thinking',
      'Team Collaboration',
      'Time Management',
      'Emotional Intelligence',
      'Confidence & Public Speaking',
      'Decision Making',
    ],
    closingParagraphs: [
      'These skills help youth grow personally and professionally while preparing them for leadership roles in society.',
    ],
  },
  {
    type: 'section',
    heading: 'Creating Positive Impact',
    paragraphs: [
      'When youth are empowered with values and leadership opportunities, they become changemakers who inspire others through action. They contribute towards building stronger communities, promoting unity, and driving national progress.',
      'Every young individual has the potential to lead - they simply need the right platform, encouragement, and direction.',
    ],
  },
  {
    type: 'section',
    heading: 'Conclusion',
    paragraphs: [
      'Transforming youth into future leaders is an investment in a better tomorrow. Through education, mentorship, discipline, and community engagement, we can inspire a generation that leads with confidence, compassion, and commitment toward the nation.',
      'Disha Foundation continues to work towards empowering youth with the vision, values, and leadership skills needed to create lasting impact in society.',
    ],
  },
]

const powerOfServiceArticle = [
  {
    type: 'intro',
    paragraphs: [
      'Service is the foundation of nation-building. When young individuals dedicate themselves to community welfare, they develop empathy, discipline, and a deep sense of responsibility toward society.',
      'At Disha Foundation, we encourage youth to participate in meaningful service initiatives that create real impact while nurturing leadership qualities.',
    ],
  },
  {
    type: 'section',
    heading: 'Why Service Matters',
    paragraphs: [
      'Community service connects youth with real challenges and teaches them the value of collective action. Through service, young leaders learn to:',
    ],
    list: [
      'Understand community needs and priorities',
      'Work collaboratively toward shared goals',
      'Develop compassion and social awareness',
      'Build trust within communities',
      'Create sustainable positive change',
    ],
    closingParagraphs: [
      'These experiences shape individuals who lead with humility and purpose.',
    ],
  },
  {
    type: 'section',
    heading: 'Nation Building Through Action',
    paragraphs: [
      'Nation-building begins at the grassroots level. Youth-led service programs strengthen communities and inspire others to contribute toward a better society.',
      'From environmental drives to educational outreach, every act of service contributes to a stronger, more united nation.',
    ],
  },
  {
    type: 'section',
    heading: 'Conclusion',
    paragraphs: [
      'The power of service lies in its ability to transform both communities and individuals. Disha Foundation remains committed to empowering youth to serve with dedication and lead with integrity.',
    ],
  },
]

const leadershipSkillsArticle = [
  {
    type: 'intro',
    paragraphs: [
      'In a rapidly changing world, leadership skills are essential for today’s youth. These skills enable young individuals to navigate challenges, inspire others, and contribute meaningfully to society.',
      'Disha Foundation provides platforms where youth can develop and practice leadership in real-world settings.',
    ],
  },
  {
    type: 'section',
    heading: 'Essential Skills For Modern Leaders',
    paragraphs: [
      'Today’s youth need a diverse set of capabilities to succeed as leaders:',
    ],
    list: [
      'Effective communication',
      'Critical and creative thinking',
      'Adaptability and resilience',
      'Ethical decision-making',
      'Team leadership and collaboration',
    ],
    closingParagraphs: [
      'Developing these skills early prepares youth for academic, professional, and civic leadership roles.',
    ],
  },
  {
    type: 'section',
    heading: 'Learning Through Experience',
    paragraphs: [
      'Leadership cannot be learned only in classrooms. Workshops, camps, and community programs give youth hands-on opportunities to practice leadership.',
      'Through mentorship and guided experiences, young individuals build confidence and discover their unique leadership style.',
    ],
  },
  {
    type: 'section',
    heading: 'Conclusion',
    paragraphs: [
      'Leadership skills matter because they empower youth to shape their own futures and the future of their communities. Disha Foundation continues to invest in programs that develop capable, value-driven young leaders.',
    ],
  },
]

export const storiesPageItems = [
  {
    slug: 'transforming-youth-into-future-leaders',
    title: 'Transforming Youth Into Future Leaders',
    date: 'May 26, 2026',
    image: sharedStory1,
    heroImage: sharedStory1,
    sections: transformingYouthArticle,
  },
  {
    slug: 'the-power-of-service-in-nation-building',
    title: 'The Power Of Service In Nation Building',
    date: 'May 18, 2026',
    image: sharedStory2,
    heroImage: sharedStory2,
    sections: powerOfServiceArticle,
  },
  {
    slug: 'why-leadership-skills-matter-for-todays-youth',
    title: "Why Leadership Skills Matter For Today's Youth",
    date: 'May 10, 2026',
    image: sharedStory3,
    heroImage: sharedStory3,
    sections: leadershipSkillsArticle,
  },
]

export const STORIES_INITIAL_COUNT = 9
export const STORIES_LOAD_MORE_COUNT = 3

export function getStoryBySlug(slug) {
  return storiesPageItems.find((story) => story.slug === slug)
}

export function buildStoriesList(count) {
  const items = []
  for (let i = 0; i < count; i += 1) {
    const story = storiesPageItems[i % storiesPageItems.length]
    items.push({ ...story, id: `${story.slug}-${i}` })
  }
  return items
}
